<template>
  <div class="regulatory-update-announcement-pf">
    <div class="regulatory-update-announcement-pf__content">
      <HeadingDisplay :title="title" :subtitle="description" size="large" />
      <div class="regulatory-update-announcement-pf__steps">
        <Row
          v-for="{ icon, label, subtitle } in steps"
          :key="label"
          :left-title="label"
          :left-subtitle="subtitle"
          :has-line="false"
        >
          <template #icon-left>
            <InitialAvatarIcon :icon="icon" size="medium" />
          </template>
        </Row>
      </div>
    </div>
    <ButtonContainer class="regulatory-update-announcement-pf__footer">
      <template #button-primary>
        <ButtonPrimary
          size="large"
          :label="navigation.title"
          @click="goToNextPage"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  HeadingDisplay,
  Row,
  InitialAvatarIcon,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import {
  RegulatoryUpdateNavigation,
  RegulatoryUpdateSteps
} from '@/modules/account/views/RegulatoryUpdate/types';
import { saveNextRoutes } from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';

@Component({
  components: {
    HeadingDisplay,
    Row,
    InitialAvatarIcon,
    ButtonContainer,
    ButtonPrimary
  }
})
export default class RegulatoryUpdateAnnouncementPF extends Vue {
  @Prop({ type: String, default: '' })
  public title!: string;

  @Prop({ type: String, default: '' })
  public description!: string;

  @Prop({ type: Array, default: () => [] })
  public steps!: RegulatoryUpdateSteps[];

  @Prop({ type: Object, default: () => ({}) })
  public navigation!: RegulatoryUpdateNavigation;

  @Emit()
  public goToNextPage() {}

  mounted() {
    if (this.navigation.actions) {
      saveNextRoutes(this.navigation.actions);
    }
  }
}
</script>

<style lang="less" scoped>
.regulatory-update-announcement-pf {
  padding-bottom: @size-spacing-x1800;

  &__content {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x1000;
  }

  &__steps {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x300;
  }

  &__footer {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: @background-secondary;
    z-index: 1;
  }
}
</style>
